export default __webpack_public_path__ + "06ac6e0c52f947d4f1369ef09f073432.mp4";